import { Analytics, IAnalyticsClient } from '@nakedplatform/support';

import { setupUser } from './user';
import { ServerAnalytics } from './server';
import * as clientExtension from './client';
import { getAnalyticsData } from './helpers';

/**
 * Setup web event listeners
 */
function setup() {
  if (typeof window !== 'undefined') {
    Analytics.configure(getClient, {
      codeRepo: 'naked-platform',
      codeSource: 'frontend',
      context_app_name: Config.Web.NAME,
      context_app_version: Config.Web.VERSION,
      context_app_build: Config.Shared.BUILD,
      experiment_identifier: 'control',
      experiment_treatment: 'control',
      language: navigator.language,
      referrer: document.referrer,
      userAgent: navigator.userAgent,
      currency: 'ZAR',
      source: 'WEB',
    });
    // TODO: Remove if this clears up Clarity noise
    // window.addEventListener('click', onClick, { passive: true });
    // window.addEventListener('scroll', onScroll, { passive: true });
    setupUser();
  }
}
/**
 * Remove web event listeners
 */
function teardown() {
  if (typeof window !== 'undefined') {
    // window.removeEventListener('click', onClick);
    // window.removeEventListener('scroll', onScroll);
  }
}
/**
 * Retrieves the appropriate Analytics client
 *
 * @param serverSide - Indicates the type of client to retrieve
 */
function getClient(serverSide: boolean) {
  let client: IAnalyticsClient;

  if (serverSide) {
    client = ServerAnalytics as IAnalyticsClient;
  } else {
    const { analytics } = window;

    if (analytics && analytics.page) {
      client = Object.assign(analytics, { screen: analytics.page }, clientExtension);
    } else if (analytics) {
      client = Object.assign(analytics, clientExtension);
    } else {
      const adblockClient = Object.assign(getAnalyticsData, clientExtension) as unknown;

      client = adblockClient as IAnalyticsClient;
    }
  }

  return client;
}
/**
 * OnCheck event handler for tracking user checkbox checks and unchecks
 *
 * @param path - the current page path / route
 * @param checkboxName - the name of the checkbox
 * @param checkboxState - the current state of the checkbox
 */
function onCheck(path: string, checkboxName: string, checkboxState: boolean) {
  Analytics.track('Checkbox Clicked', {
    path,
    checkboxName,
    checkboxState,
  });
}
export const WebAnalytics = {
  setup,
  teardown,
  onCheck,
};
